import Appsignal from "@appsignal/javascript";
import { plugin as breadcrumbsPlugin } from "@appsignal/plugin-breadcrumbs-console";
import { plugin as windowEventsPlugin } from "@appsignal/plugin-window-events";
import { devlog } from "./utils";

devlog(`Appsignal for JS in ${process.env.NODE_ENV} mode`);
const appRevision = document.body.dataset.appRevision;
devlog(`App version: ${appRevision}`);

const appsignal = new Appsignal({
  key: process.env.ESBUILD_APPSIGNAL_FRONTEND_API_KEY,
  revision: appRevision,
  ignoreErrors: [
    // ignore error that appears to be coming from outlook link scanning, see
    // https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-865857552
    /Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/m,
  ],
});

appsignal.use(breadcrumbsPlugin());
appsignal.use(windowEventsPlugin());

// expose appsignal JS to the console for testing by uncommenting the line below
// window.appsignal = appsignal;

export default appsignal;
